module.exports = __webpack_public_path__ + "static/media/SVG_read.071213ba.svg";